import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.fetchAndRenderIcons();
		this.fetchAndRenderCustomProps();
	}

	async fetchAndRenderIcons() {
		try {
			const response = await fetch("/wp-json/icons-list/v1/icons"); // Correct API route
			const icons = await response.json();

			if (!Array.isArray(icons)) {
				throw new Error("Expected an array but got " + typeof icons);
			}

			const iconsContainer = document.querySelector(".js-icons");
			if (!iconsContainer) {
				console.error("No container with class 'js-icons' found.");
				return;
			}

			iconsContainer.innerHTML = icons.map((icon) => `<i class="o-icon -${icon}"></i>`).join("");
		} catch (error) {
			console.error("Error fetching icons:", error);
		}
	}

	fetchAndRenderCustomProps() {
		/**
		 * Check if the stylesheet is internal or hosted on the current domain.
		 * This prevents cross-origin errors when accessing `cssRules`.
		 */
		const isSameDomain = (styleSheet) => {
			if (!styleSheet.href) return true;
			return styleSheet.href.indexOf(window.location.origin) === 0;
		};

		/**
		 * Determine if a CSS rule is a Style Rule (type === 1).
		 */
		const isStyleRule = (rule) => rule.type === 1;

		/**
		 * Get all CSS custom properties (`--variables`) from stylesheets that match specific keywords and exclude `rgb` values in the property name.
		 * @return array<array<string, string>> - An array of [property, value] pairs.
		 */
		const getCSSCustomPropIndex = () => {
			const keywords = ["--primary", "--secondary", "--neutral", "--accent", "--error"]; //add more keywords
			return [...document.styleSheets]
				.filter(isSameDomain) // Filter only stylesheets from the same domain
				.reduce((finalArr, sheet) => {
					try {
						return finalArr.concat(
							[...sheet.cssRules]
								.filter(isStyleRule) // Only CSS style rules
								.reduce((propValArr, rule) => {
									const props = [...rule.style]
										.map((propName) => [propName.trim(), rule.style.getPropertyValue(propName).trim()])
										.filter(
											([propName, propValue]) => propName.startsWith("--") && keywords.some((keyword) => propName.includes(keyword)) && !propName.includes("-rgb") // Exclude properties containing '-rgb' in the name
										); // Only matching and valid custom props
									return [...propValArr, ...props];
								}, [])
						);
					} catch (e) {
						console.warn(`Could not access cssRules for stylesheet: ${sheet.href}`, e);
						return finalArr;
					}
				}, []);
		};

		// Fetch custom properties
		const cssCustomPropIndex = getCSSCustomPropIndex();

		// Reference the container to display the custom properties
		const colorsContainer = document.querySelector(".colors");
		if (!colorsContainer) {
			console.error("No container with class 'colors' found.");
			return;
		}

		// Render custom properties in the container
		colorsContainer.innerHTML = `
      <ul class="o-grid -cols-4 -gutter color-list">
        ${cssCustomPropIndex
			.map(
				([prop, val]) => `
          <li class="swatch u-bg-${prop.replace(/^([^-\n]*-[^-\n]*-)/, "")}">
                
            <span class="o-layout -col o-typography -title-small">
                <span>u-bg-${prop.replace(/^([^-\n]*-[^-\n]*-)/, "")}</span>
                <span>${val}</span>
            </span>
                          
            </div>
          </li>`
			)
			.join("")}
      </ul>
    `;
	}

	destroy() {
		console.log("Module destroyed.");
	}
}
